import { lazy } from 'react';

import { BaseRoles, RoleVariantEnum } from 'common/graphql/types';
import { SUPPORT_ROLES } from 'common/utils/user';

export const STUDY_REPORTS_PATH = '/studyreports/:studyId/:reportInfo/:dashboardId?';

export const routes = [
    {
        component: lazy(() => import('module/studyreports/studyreports.page')),
        role: [
            BaseRoles.AdminId,
            RoleVariantEnum.ClinicalTrialLead,
            RoleVariantEnum.StudyBuilder,
            RoleVariantEnum.StudySupport,
            RoleVariantEnum.BlindedStudyManager,
            RoleVariantEnum.AdminReadOnly,
            ...SUPPORT_ROLES,
        ],
        path: STUDY_REPORTS_PATH,
    },
];
